module.exports = __webpack_public_path__ + "static/img/1.a29e740d.png";